.dd{padding:0.5rem;}